<template>
  <b-modal
    :id="`complete-checkin-modal${id}`"
    modal-class="modal-style"
    ref="modal"
    v-model="modal"
  >
    <template>
      <p class="modal-style-title not-one-row">
        {{ courseCheckingLog.course_name }}
        {{ courseCheckingLog.course_start_at }}
      </p>
      <div class="modal-style-content">
        <p class="modal-style-content__mobile">
          {{ courseCheckingLog.member_phone }}
        </p>
        <p>{{ courseCheckingLog.member_name }} 報到完成</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    },
    courseCheckingLog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`complete-checkin-modal${this.id}`);
    }
  }
};
</script>
